import axios from "axios";
import { userPermissionsList } from "@/constants/userPermissions";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';
import moment from 'moment';

const apiUrl = "index.php";

const convertObjectCollectionForSelect = (collection) => {
    const collectionArray = [];
    Object.entries(collection).forEach(([itemId, itemName]) => {
        collectionArray.push({
            label: itemName,
            value: itemId,
        });
    });
    return collectionArray;
};

const convertCollectionForSelect = (collection, isSchedules = false, isLawsStatus = false) =>
    collection.map((c) => {
        let r = {
            label: isSchedules ? c.description : c.name,
            value: c.id,
        };
        if (isLawsStatus) {
            r.citizenships = c.citizenships;
        }
        return r;
    });

const convertEmployeeDataForRequest = (employeeData) => ({
    name: employeeData.fullName,
    filial_id: employeeData.filial.value,
    company_id: employeeData.company && employeeData.company.value,
    timex_server: employeeData.timexServer && employeeData.timexServer.value,
    dative_name: employeeData.fullNameDativeCase,
    agreement_number: employeeData.agreementNumber,
    hiring_date: employeeData.hiringDate ? moment(employeeData.hiringDate, "DD.MM.YYYY").format("YYYY-MM-DD") : null,
    agreement_date: employeeData.agreementDate ? moment(employeeData.agreementDate, "DD.MM.YYYY").format("YYYY-MM-DD") : null,
    hiring_date_official: employeeData.hiringDateOfficial ? moment(employeeData.hiringDateOfficial, "DD.MM.YYYY").format("YYYY-MM-DD") : null,

    dismissal_date: employeeData.dismissalDate ? moment(employeeData.dismissalDate, "DD.MM.YYYY").format("YYYY-MM-DD") : null,
    genitive_name: employeeData.fullNameGenitiveCase,
    citizenship: employeeData.citizenship ? employeeData.citizenship.value : null,
    law_status_id: employeeData.lawStatus ? employeeData.lawStatus.value : null,
    is_worker: employeeData.workerStatus ? employeeData.workerStatus.value : null,
    worker_status_id: employeeData.workerCharacteristic ? employeeData.workerCharacteristic.value : null,
    learning_status_id: employeeData.employmentStatus ? employeeData.employmentStatus.value : null,
    schedule_id: employeeData.schedule ? employeeData.schedule.value : null,
    work_shift_type: employeeData.shiftType ? employeeData.shiftType.value : null,
    mentor_id: employeeData.mentor ? employeeData.mentor.value : null,
    timex: employeeData.timexNumber,
    iiko_user_code: employeeData.iikoCode,
    pay_salary_on_account: employeeData.payOnPersonalAccount ? 1 : 0,
    combination_filials: employeeData.isAbleToWorkInDifferentFilials ? 1 : 0,
    can_work_remotely: employeeData.isAbleToWorkRemotely ? 1 : 0,
    positions: employeeData.positions.map((p) => ({
        post_code: p.position.value,
        category_id: p.rank ? p.rank.value : null,
        specialty_id: p.specialty ? p.specialty.value : null,
        salary: p.salary,
    })),
    deposit: employeeData.depositAmount,
});

const convertEmployeeDataFromServer = (data, state) => {
    const positionsCollection = [];
    const ranksCollection = [];
    const specialtiesCollection = [];

    Object.entries(state.collections.positions).forEach(([positionCode, positionObject]) => {
        positionsCollection.push({
            label: positionObject.name,
            value: positionCode,
        });
        if (positionObject.categories && !Array.isArray(positionObject.categories)) {
            Object.entries(positionObject.categories).forEach(([rankCode, rank]) => {
                ranksCollection.push({
                    label: rank,
                    value: rankCode,
                });
            });
        }
        if (positionObject.specialties && !Array.isArray(positionObject.specialties)) {
            Object.entries(positionObject.specialties).forEach(([specialtyCode, specialty]) => {
                specialtiesCollection.push({
                    label: specialty,
                    value: specialtyCode,
                });
            });
        }
    });

    const {
        name,
        dative_name,
        genitive_name,
        company_id,
        citizenship,
        law_status_id,
        filial_id,
        is_worker,
        worker_status_id,
        learning_status_id,
        schedule_id,
        work_shift_type,
        mentor_id,
        timex_server,
        timex,
        iiko_user_code,
        deposit,
        pay_salary_on_account,
        combination_filials,
        can_work_remotely,
        workerPosts,
        hiring_date,
        hiring_date_official,
        dismissal_date,
        agreement_date,
        agreement_number,
    } = data;

    const r = {
        fullName: name,
        hiringDate: hiring_date ? moment(hiring_date, "YYYY-MM-DD").format("DD.MM.YYYY") : null,
        agreementDate: agreement_date ? moment(agreement_date, "YYYY-MM-DD").format("DD.MM.YYYY") : null,
        agreementNumber: agreement_number,
        hiringDateOfficial: hiring_date_official ? moment(hiring_date_official, "YYYY-MM-DD").format("DD.MM.YYYY") : null,
        dismissalDate: dismissal_date ? moment(dismissal_date, "YYYY-MM-DD").format("DD.MM.YYYY") : null,
        fullNameDativeCase: dative_name,
        fullNameGenitiveCase: genitive_name,
        company: company_id ? state.collections.companies.find((c) => c.value === company_id.toString()) : null,
        citizenship: citizenship ? state.collections.citizenships.find((c) => c.value === citizenship) : null,
        lawStatus: law_status_id ? state.collections.lawStatuses.find((s) => s.value === law_status_id) : null,
        filial: state.collections.filials.find((f) => f.value === filial_id.toString()),
        workerStatus: is_worker ? state.collections.workerStatuses.find((s) => s.value === is_worker) : null,
        workerCharacteristic: worker_status_id
            ? state.collections.workerCharacteristics.find((c) => c.value === worker_status_id)
            : null,
        employmentStatus: learning_status_id
            ? state.collections.employmentStatuses.find((s) => s.value === learning_status_id)
            : null,
        schedule: schedule_id ? state.collections.schedules.find((s) => s.value === schedule_id) : null,
        shiftType: work_shift_type ? state.collections.shiftTypes.find((t) => t.value === work_shift_type) : null,
        mentor: mentor_id ? state.collections.mentors.find((m) => m.value === mentor_id.toString()) : null,
        timexServer: state.collections.timexServers.find((s) => s.value === timex_server),
        timexNumber: timex,
        iikoCode: iiko_user_code,
        depositAmount: deposit || null,
        payOnPersonalAccount: !!pay_salary_on_account,
        isAbleToWorkInDifferentFilials: !!combination_filials,
        isAbleToWorkRemotely: !!can_work_remotely,
        positions: workerPosts.map((position) => ({
            position: positionsCollection.find((p) => p.value === position.post_code),
            rank: position.category_id
                ? ranksCollection.find((r) => r.value.toString() === position.category_id.toString())
                : null,
            specialty: position.specialty_id
                ? specialtiesCollection.find((s) => s.value.toString() === position.specialty_id.toString())
                : null,
            salary: position.salary,
        })),
    };
    return r;

};

const state = () => ({
    collections: {
        citizenships: [],
        lawStatuses: [],
        filials: [],
        positions: {},
        mentors: [],
        timexServers: [],
        workerStatuses: [],
        workerCharacteristics: [],
        employmentStatuses: [],
        schedules: [],
        companies: [],
        shiftTypes: [
            {
                label: "Дневная",
                value: "day",
            },
            {
                label: "Ночная",
                value: "night",
            },
        ],
    },
});

const getters = {
    isAllowedToEditAllWorkers(_, __, rootState) {
        return rootState.userPermissions.includes(userPermissionsList.worker.controlAll) || rootState.userPermissions.includes(userPermissionsList.worker.controlOwn);
    },
};

const mutations = {
    setCitizenships(state, citizenships) {
        state.collections.citizenships = convertCollectionForSelect(citizenships);
    },
    setLawStatuses(state, lawStatuses) {
        state.collections.lawStatuses = convertCollectionForSelect(lawStatuses, false, true);
    },
    setFilials(state, filials) {
        state.collections.filials = convertObjectCollectionForSelect(filials);
    },
    setPositionsWithRanksAndSpecialties(state, positions) {
        state.collections.positions = positions;
    },
    setMentors(state, mentors) {
        const sortedArray = convertObjectCollectionForSelect(mentors);
        sortedArray.sort((a, b) => {
            const nameA = a.label.toLowerCase().trim();
            const nameB = b.label.toLowerCase().trim();

            if (nameA > nameB) {
                return 1;
            }
            if (nameA < nameB) {
                return -1;
            }
            return 0;
        });

        state.collections.mentors = sortedArray;
    },
    setTimexServers(state, servers) {
        state.collections.timexServers = convertObjectCollectionForSelect(servers);
    },
    setWorkerStatuses(state, statuses) {
        state.collections.workerStatuses = convertCollectionForSelect(statuses);
    },
    setWorkerCharacteristics(state, characteristics) {
        state.collections.workerCharacteristics = convertCollectionForSelect(characteristics);
    },
    setEmploymentStatuses(state, statuses) {
        state.collections.employmentStatuses = convertCollectionForSelect(statuses);
    },
    setSchedules(state, schedules) {
        state.collections.schedules = convertCollectionForSelect(schedules, true);
    },
    setCompanies(state, companies) {
        state.collections.companies = convertObjectCollectionForSelect(companies);
    },
};

const actions = {
    fetchCollections({ rootState, commit }) {
        const token = rootState.authToken;
        const routes = [
            {
                route: "directory/citizenship",
                commitName: "setCitizenships",
                statusType: "",
            },
            {
                route: "directory/law-status",
                commitName: "setLawStatuses",
                statusType: "",
            },
            {
                route: "directory/filial",
                commitName: "setFilials",
                statusType: "",
            },
            {
                route: "directory/mentor",
                commitName: "setMentors",
                statusType: "",
            },
            {
                route: "directory/position",
                commitName: "setPositionsWithRanksAndSpecialties",
                statusType: "",
            },
            {
                route: "directory/timex",
                commitName: "setTimexServers",
                statusType: "",
            },
            {
                route: "worker-status/index",
                commitName: "setWorkerStatuses",
                statusType: "active",
            },
            {
                route: "worker-type/index",
                commitName: "setWorkerCharacteristics",
                statusType: "active",
            },
            {
                route: "vacancy-status/index",
                commitName: "setEmploymentStatuses",
                statusType: "active",
            },
            {
                route: "schedule/index",
                commitName: "setSchedules",
                statusType: "",
            },
            {
                route: "directory/company",
                commitName: "setCompanies",
                statusType: "",
            },
        ];

        routes.forEach(async ({ route, commitName, statusType }) => {
            let url = addAuthKey(`${apiUrl}/?r=api/${route}&sort=-sort&formWorker=1`, token);
            if (statusType) {
                url += `&status_type=${statusType}`;
            }
            const { data } = await axios.get(url);
            commit(commitName, data);
        });
    },
    async createEmployee({ rootState }, employeeData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/employee/create`, token);

        const employeeRequestData = convertEmployeeDataForRequest(employeeData);

        const { data } = await axios.post(url, employeeRequestData, {
            validateStatus: status => status < 500
        });

        return data;
    },
    async checkEmployeeDuplicate({ rootState }, params) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/worker/cheek-dublicate`, token);

        const { data } = await axios.post(url, params, {
            validateStatus: status => status < 500
        });

        return data;
    },
    async updateEmployee({ rootState }, employeeData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/employee/update&id=${employeeData.id}`, token);

        const employeeRequestData = convertEmployeeDataForRequest(employeeData);

        const { data } = await axios.post(url, employeeRequestData, {
            validateStatus: status => status < 500
        });

        return data;
    },
    async newAgreementNumber({ rootState }, employeeData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/employee/new-agreement-number`, token);

        const { data } = await axios.post(url, employeeData, {
            validateStatus: status => status < 500
        });

        return data;
    },
    async getEmployeeInfo({ rootState, state }, employeeId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/employee/view&id=${employeeId}`, token);

        const { data } = await axios.get(url);

        return convertEmployeeDataFromServer(data, state);
    },
    async deleteEmployee({ rootState }, employeeId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/employee/delete&id=${employeeId}`, token);

        const { data } = await axios.delete(url);

        return data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
